<h1 class="page col-md-6 mb-4 mt-2">Order Tickets View</h1>
<div class="d-flex justify-content-between mt-5 laptop" >
    <div class="position-relative col-md-3 "  style="visibility: hidden;">
        <input type="text" class="form-control search-input" placeholder="Search...."
            (keyup)="applyFilter1($event.target)">
        <span class="ri-search-line search-icon"></span>
    </div>

    <div class="border text-whhite d-flex justify-content-end page-top">
        <mat-paginator class="bg-transparent" [hidden]="apiData?.length==0" [length]="this.length"
          [pageSizeOptions]="[10, 25, 50]" [(pageSize)]="paginate.pageSize" (page)="onPageChange($event)"></mat-paginator>
    </div>
</div>
<div class="justify-content-center mt-5 mobile">
    <div class="position-relative col-md-3">
        <input type="text" class="form-control search-input" placeholder="Search...."
            (keyup)="applyFilter1($event.target)">
        <span class="ri-search-line search-icon"></span>
    </div>

    <div class="border text-whhite d-flex justify-content-center page-top mt-3">
        <mat-paginator class="bg-transparent" [hidden]="apiData?.length==0" [length]="this.length"
          [pageSizeOptions]="[10, 25, 50]" [(pageSize)]="paginate.pageSize" (page)="onPageChange($event)"></mat-paginator>
    </div>
</div>
<!-- <div class="d-flex justify-content-end"> 
    <div class="border text-whhite d-flex justify-content-between" >
        <div class="position-relative col-md-3">
            <input type="text" class="form-control search-input" placeholder="Search...." (keyup)="applyFilter1($event.target)">
            <span class="ri-search-line search-icon"></span>
        </div>
        <mat-paginator class="bg-transparent" [hidden]="apiData?.length==0" [length]="length"
        [pageSizeOptions]="[10, 25, 50]"
        (page)="pageEvent=fetchData($event)"></mat-paginator>
    </div>
</div> -->
<div class="d-flex justify-content-between">
    <div>
    <button type="button" class="btn btn-sm btn-light mt-3"  [ngClass]="{ 'bg-primary1': currentFilter === 'open', 'bg-light1': currentFilter !== 'open' }" (click)="setFilter('open')" style="color: black!important;">Open</button>
<button type="button" class="btn btn-sm btn-light mt-3  ms-3"  [ngClass]="{ 'bg-primary1': currentFilter === 'close', 'bg-light1': currentFilter !== 'close' }" (click)="setFilter('close')" style="color: black!important;">Close</button>
<button type="button" class="btn btn-sm btn-light mt-3  ms-3"  [ngClass]="{ 'bg-primary1': currentFilter === 'all', 'bg-light1': currentFilter !== 'all' }" (click)="setFilter('all')" style="color: black!important;">All</button>
</div>
<div>
    <button  type="button" class="btn btn-sm btn-primary mt-3  ms-3 p-2"  (click)="download()">Download Tickets</button>
    <button  type="button" class="btn btn-sm btn-danger mt-3  ms-3 p-2"  (click)="download1()">Reset Filters</button>
</div>
</div>
<div class="row d-flex justify-content-center p-4">
    <div class="card-body" style="background-color:transparent;">
        <div class="material-datatables">
            <div class="position-relative overflow-auto">
                <table class="table table-no-bordered table-hover" mat-table [dataSource]="customers" matSort>
                    <ng-container [matColumnDef]="tableheader" *ngFor="let tableheader of displayedColumns; index as i"
                        [stickyEnd]="tableheader == 'actions'">
                        <!-- <th mat-header-cell *matHeaderCellDef class="text-center text-primary text-bold"
                            mat-sort-header style="white-space: nowrap;">
                            {{ headerData[tableheader] }}
                        </th> -->
                        <ng-container *ngIf="tableheader === 'ticket_id'">
                            <th mat-header-cell *matHeaderCellDef class="text-center text-primary text-bold"
                                mat-sort-header style="white-space: nowrap;">
                                
                                <span>Ticket Id & Order Id</span>
                                <i class="fa fa-filter pl-2 ms-2" (click)="open(InvoicenumberTemplate)" style="font-size: 10px; cursor: pointer;"></i>

                            </th>
                            <!-- <td mat-cell class="text-center align-middle" style="white-space: nowrap; font-size: 12px;"
                                *matCellDef="let row; index as i">
                                <span [style.color]="isUnreadTicket(row['ticket_id']) ? 'red' : 'blue'" (click)="ticket_details(row)">{{
                                    row['ticket_id'] }}</span><br>
                                <span>{{ row['order_id'] }}</span>

                            </td> -->
                            <!-- <td mat-cell class="text-center align-middle" style="white-space: nowrap; font-size: 12px;" *matCellDef="let row; index as i">
                                <span [style.color]="isUnreadTicket(row['ticket_id']) ? 'red' : 'blue'" style="cursor: pointer;" 
                                      [ngClass]="{'clickable': isUnreadTicket(row['ticket_id'])}"
                                      (click)="isUnreadTicket(row['ticket_id']) ? ticket_update(row['ticket_id']) : ticket_details(row)">
                                  {{ row['ticket_id'] }}
                                </span><br>
                                <span>{{ row['order_id'] }}</span>
                            </td> -->
                            <td mat-cell class="text-center align-middle" style="white-space: nowrap; font-size: 12px;" *matCellDef="let row; index as i">
                                <span [style.color]="isUnreadTicket(row['ticket_id']) ? 'red' : 'blue'" style="cursor: pointer;" 
                                      [ngClass]="{'clickable': isUnreadTicket(row['ticket_id'])}"
                                      (click)="handleTicketClick(row)">
                                  {{ row['ticket_id'] }}
                                </span><br>
                                <span>{{ row['order_id'] }}</span>
                            </td>
                              
                              
                        </ng-container>
                        <ng-container *ngIf="tableheader === 'image1'">
                            <th mat-header-cell *matHeaderCellDef class="text-center text-primary text-bold"
                                mat-sort-header style="white-space: nowrap;">
                                {{ headerData[tableheader] }}
                            </th>
                            <td mat-cell class="text-center align-middle" style="white-space: nowrap; font-size: 12px;" *matCellDef="let row; index as i">
                                <img src="assets/images/download.png" height="24px" width="24px" style="cursor: pointer;" title="Download Image" (click)="downloadImage(row['image1'])">
                              </td>
                                                          
                            <!-- <td mat-cell class="text-center align-middle" style="white-space: nowrap; font-size: 12px;"
                                *matCellDef="let row; index as i">
                                <span>{{ row[tableheader] }}</span>
                            </td> -->
                        </ng-container>
                        <ng-container *ngIf="tableheader === 'image2'">
                            <th mat-header-cell *matHeaderCellDef class="text-center text-primary text-bold"
                                mat-sort-header style="white-space: nowrap;">
                                {{ headerData[tableheader] }}
                            </th>
                            <td mat-cell class="text-center align-middle" style="white-space: nowrap; font-size: 12px;" *matCellDef="let row; index as i">
                                <img src="assets/images/download.png" height="24px" width="24px" style="cursor: pointer;" title="Download Image" (click)="downloadImage(row['image2'])">
                              </td>                            
                            <!-- <td mat-cell class="text-center align-middle" style="white-space: nowrap; font-size: 12px;"
                                *matCellDef="let row; index as i">
                                <span>{{ row[tableheader] }}</span>
                            </td> -->
                        </ng-container>
                        <ng-container *ngIf="tableheader !== 'ticket_id' && tableheader !== 'image1' && tableheader !== 'image2'">
                            <th mat-header-cell *matHeaderCellDef class="text-center text-primary text-bold"
                                mat-sort-header style="width: auto!important;white-space: nowrap;">
                                <span> {{ headerData[tableheader] }}</span>
                                   <span *ngIf="headerData[tableheader] == 'Category'" class="filter-icon"  style="white-space: nowrap;padding-left: 5px;">
                  <i class="fa fa-filter pl-2" (click)="openDropdown()" style="font-size: 10px; cursor: pointer;"></i>
                  <mat-select #select  [formControl]="vendorForm" style="border: none; background: none; -webkit-appearance: none; -moz-appearance: none; appearance: none;" class="hide-arrow">
                      <!-- <mat-form-field class="p-2">
                          <div class="d-flex justify-content-between cursor">
                              <input matInput autocomplete="off" (input)="applyFilterVendor($event.target.value)" />
                          </div>
                      </mat-form-field> -->
                      <mat-option *ngFor="let zone of filteredPortal" (click)="closedFilter()" [value]="zone.status">
                          {{ zone.name }}
                      </mat-option>
                  </mat-select>
              </span>
             <span *ngIf="headerData[tableheader] == 'Created At' "    style="white-space: nowrap;padding-left: 5px;">
                                  <span class="fa fa-calendar pt-5" style="color: black;font-weight: bold;" (click)="resolvedDatePicker.open()"></span>
                                  <mat-form-field style="font-size: 0px;width: 0px; opacity: 0;">
                                    <mat-date-range-input [rangePicker]="resolvedDatePicker">
                                      <input matInput matStartDate [formControl]="resolvedDate_start_date" placeholder="Start date">
                                      <input matInput matEndDate [formControl]="resolvedDate_end_date" placeholder="End date">
                                    </mat-date-range-input>
                                    <mat-datepicker-toggle matSuffix [for]="resolvedDatePicker"></mat-datepicker-toggle>
                                    <mat-date-range-picker #resolvedDatePicker>
                                      <mat-datepicker-actions>
                                        <button mat-raised-button color="primary" matDatepickerApply (click)="closedFilter()">Apply</button>
                                      </mat-datepicker-actions>
                                    </mat-date-range-picker>
                                  </mat-form-field>
                                </span>
                                 <span *ngIf="headerData[tableheader] == 'Updated At' "    style="white-space: nowrap;padding-left: 5px;">
                                  <span class="fa fa-calendar pt-5" style="color: black;font-weight: bold;" (click)="resolvedDatePicker1.open()"></span>
                                  <mat-form-field style="font-size: 0px;width: 0px; opacity: 0;">
                                    <mat-date-range-input [rangePicker]="resolvedDatePicker1">
                                      <input matInput matStartDate [formControl]="resolvedDate_start_date1" placeholder="Start date">
                                      <input matInput matEndDate [formControl]="resolvedDate_end_date1" placeholder="End date">
                                    </mat-date-range-input>
                                    <mat-datepicker-toggle matSuffix [for]="resolvedDatePicker1"></mat-datepicker-toggle>
                                    <mat-date-range-picker #resolvedDatePicker1>
                                      <mat-datepicker-actions>
                                        <button mat-raised-button color="primary" matDatepickerApply (click)="closedFilter()">Apply</button>
                                      </mat-datepicker-actions>
                                    </mat-date-range-picker>
                                  </mat-form-field>
                                </span>
                                   <span *ngIf="headerData[tableheader] == 'Raised By' "    style="white-space: nowrap;padding-left: 5px;">
                  <i class="fa fa-filter pl-2"  (click)="open(InvoicenumberTemplate1)" style="font-size: 10px; cursor: pointer;"></i>
                                  </span>
                                   <span *ngIf="headerData[tableheader] == 'Updated By' "    style="white-space: nowrap;padding-left: 5px;">
                  <i class="fa fa-filter pl-2"  (click)="open(InvoicenumberTemplate2)" style="font-size: 10px; cursor: pointer;"></i>
                                  </span>
                    

                               
                            </th>
                                                          <ng-container *ngIf="tableheader == 'category'">
                          <td mat-cell class="text-center hover" *matCellDef="let row; index as i">
                              <span class="d-flex">
                                <span  style="white-space: nowrap;
    font-size: 12px;">{{
                                  row[tableheader] }}</span>
                                  <span class="ml-2">
                                      <i class="fa fa-edit pl-2 ms-3" [matMenuTriggerFor]="menu" style="cursor: pointer;"  (click)="editDependency(row)"  ></i>
                                  </span>
                              </span>
                          </td>
                      </ng-container>
                       <mat-menu #menu="matMenu">
                          <button mat-menu-item class=" " *ngFor="let dd of dependencyDropDown"  (click)="saveDependency(dd.status)" >{{dd.name}} </button>
                       </mat-menu>
                            <td mat-cell class="text-center align-middle" style="white-space: nowrap; font-size: 12px;"
                                *matCellDef="let row; index as i">
                                <span>{{ row[tableheader] }}</span>
                            </td>
                        </ng-container>

                        <!-- <ng-container *ngIf="tableheader === 'ticket_id' || tableheader === 'order_id'">
                            <td mat-cell class="text-center align-middle"
                                style="white-space: nowrap; font-size: 12px; cursor: pointer; color: blue;"
                                *matCellDef="let row; index as i" (click)="ticket_details(row)">
                                <span>{{ row['ticket_id'] }}</span><br>
                                <span>{{ row['order_id'] }}</span>
                                    
                            </td>
                        </ng-container>
                        <ng-container *ngIf="tableheader !== 'ticket_id' && tableheader !== 'order_id'">
                            <td mat-cell class="text-center align-middle"
                                style="white-space: nowrap; font-size: 12px;"
                                *matCellDef="let row; index as i">
                                <span>{{ row[tableheader] }}</span>
                            </td>
                        </ng-container> -->

                        <!-- <ng-container *ngIf="tableheader=='ticket_id'">
                            <td mat-cell class="text-center align-middle"
                            style="white-space: nowrap; font-size: 12px; cursor: pointer; color: blue;"
                            *matCellDef="let row; index as i" (click)="ticket_details(row)">
                            <span>{{ row[tableheader] }}</span>
                        </td>
                        </ng-container> -->
                        <!-- <ng-container *ngIf="tableheader=='raised_by'">
                            <td mat-cell class="text-center align-middle"
                            style="white-space: nowrap; font-size: 12px; cursor: pointer;"
                            *matCellDef="let row; index as i" >
                            <span>{{ row[tableheader] }}</span><span><img src="assets/images/edit22.png" height="20px" width="20px"></span>
                        </td>
                        </ng-container> -->
                        <!-- <ng-container *ngIf="tableheader !== 'ticket_id'">
                            <td mat-cell class="text-center align-middle"
                                style="white-space: nowrap; font-size: 12px;"
                                *matCellDef="let row; index as i">
                                <span>{{ row[tableheader] }}</span>
                            </td>
                        </ng-container> -->

                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                </table>

            </div>
        </div>
        <div class="border text-whhite d-flex justify-content-end page-bottom">
            <mat-paginator class="bg-transparent" [hidden]="apiData?.length==0" [length]="this.length"
              [pageSizeOptions]="[10, 25, 50]" [(pageSize)]="paginate.pageSize" (page)="onPageChange($event)"></mat-paginator>
        </div>
    </div>


</div>
<ng-template #InvoicenumberTemplate let-modal>
    <div class="modal-content">
        <div class="modal-header">
            <h4 class="card-title mb-0 flex-grow-1">Filter Order Id</h4>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" id="btn-close" (click)="modal.dismiss('Cross click')"></button>
        </div>
        <div class="modal-body">
            <div class="d-flex gap-2 justify-content-center mt-4 mb-2">
                <div class="col-md-8">
                    <label class="form-label">Search Order Id</label>
<input 
  type="text" 
  class="form-control" 
  placeholder="Enter Order ID"
  [formControl]="search_order_id">

                </div>
            </div>
            <div class="d-flex gap-2 justify-content-center mt-4 mb-2">
                <button type="button" class="btn w-sm btn-danger" (click)="download1()" id="deleteRecord-close">Remove Filter</button>
                <button type="button" class="btn w-sm btn-success " id="delete-product" (click)="download2()">Filter</button>
            </div>
        </div>
    </div>
    <ng-container *ngIf="showOverlay" id="overlay-container">
        <app-spinner [overlay]="true" id="loader"></app-spinner>
    </ng-container>
</ng-template>
<ng-template #InvoicenumberTemplate1 let-modal>
    <div class="modal-content">
        <div class="modal-header">
            <h4 class="card-title mb-0 flex-grow-1">Filter Raised By</h4>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" id="btn-close" (click)="modal.dismiss('Cross click')"></button>
        </div>
        <div class="modal-body">
            <div class="d-flex gap-2 justify-content-center mt-4 mb-2">
                <div class="col-md-8">
                    <label class="form-label">Search Raised By</label>
<input 
  type="text" 
  class="form-control" 
  placeholder="Enter Raised By"
  [formControl]="search_order_id1">

                </div>
            </div>
            <div class="d-flex gap-2 justify-content-center mt-4 mb-2">
                <button type="button" class="btn w-sm btn-danger" (click)="download1()" id="deleteRecord-close">Remove Filter</button>
                <button type="button" class="btn w-sm btn-success " id="delete-product" (click)="download2()">Filter</button>
            </div>
        </div>
    </div>
    <ng-container *ngIf="showOverlay" id="overlay-container">
        <app-spinner [overlay]="true" id="loader"></app-spinner>
    </ng-container>
</ng-template>
<ng-template #InvoicenumberTemplate2 let-modal>
    <div class="modal-content">
        <div class="modal-header">
            <h4 class="card-title mb-0 flex-grow-1">Filter Updated By</h4>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" id="btn-close" (click)="modal.dismiss('Cross click')"></button>
        </div>
        <div class="modal-body">
            <div class="d-flex gap-2 justify-content-center mt-4 mb-2">
                <div class="col-md-8">
                    <label class="form-label">Select User</label>
                    <ng-select appearance="outline" [formControl]="updated_by">
                        <ng-option *ngFor="let data of userdata" [value]="data.username">
                            {{data.username}}
                        </ng-option>
                    </ng-select>
                    <!-- <div *ngIf="client_Filter_form.invalid && client_Filter_form.touched" class="text-danger">
                        <small *ngIf="client_Filter_form.hasError('required')">Client Name is required.</small>
                    </div> -->
                </div>
            </div>
            <div class="d-flex gap-2 justify-content-center mt-4 mb-2">
                <button type="button" class="btn w-sm btn-danger" (click)="download1()" id="deleteRecord-close">Remove Filter</button>
                <button type="button" class="btn w-sm btn-success " id="delete-product" (click)="download2()">Filter</button>
            </div>
        </div>
    </div>
    <ng-container *ngIf="showOverlay" id="overlay-container">
        <app-spinner [overlay]="true" id="loader"></app-spinner>
    </ng-container>
</ng-template>
<ng-container *ngIf="showOverlay" id="overlay-container">
    <app-spinner [overlay]="true" id="loader"></app-spinner>
</ng-container>